import { EditorState, LexicalEditor } from 'lexical';

import {LexicalComposer} from '@lexical/react/LexicalComposer';
import {RichTextPlugin} from '@lexical/react/LexicalRichTextPlugin';
import {ContentEditable} from '@lexical/react/LexicalContentEditable';
import {LexicalErrorBoundary} from '@lexical/react/LexicalErrorBoundary';
import { EditorRefPlugin } from '@lexical/react/LexicalEditorRefPlugin';
import { OnChangePlugin } from '@lexical/react/LexicalOnChangePlugin';

import EnterCommandPlugin from './commands/ActionOnEnter';
import { ThriveTextConfigOptions } from './interfaces';

const theme = {
  // Theme styling goes here
  //...
}

// Catch any errors that occur during Lexical updates and log them
// or throw them as needed. If you don't throw them, Lexical will
// try to recover gracefully without losing user data.
function onError(error:any) {
  console.error(error);
}

function Editor({placeholder, id, options}:Readonly<{placeholder?: {text: string, className: string}, id?: string, options?: ThriveTextConfigOptions}>): React.JSX.Element {

    const initialConfig = {
    namespace: 'MyEditor',
    theme,
    onError,
  };

  return (
    <LexicalComposer initialConfig={initialConfig}>
       {!!options?.hasEditorRef && <EditorRefPlugin editorRef={options?.editorRef as (instance: LexicalEditor | null) => void} /> }
      <RichTextPlugin
        contentEditable={
          <>
            <ContentEditable
              id={id}
              aria-placeholder={placeholder?.text ?? ''}
              placeholder={placeholder?.text ? <div className={placeholder?.className}>{placeholder?.text}</div> : <></>}
            />
            {!!options?.onReturnKeyPressed && <EnterCommandPlugin onEnter={options.onReturnKeyPressed} />}
            {!!options?.onChange && <OnChangePlugin onChange={options.onChange} />}
          </>
        }
        ErrorBoundary={LexicalErrorBoundary}
      />
    </LexicalComposer>
  );
}

export default Editor;